import React, { FC, Fragment, useEffect, useState } from 'react';
import { Loader } from '@shared/uikit/loader';
import { useClientsIndicator } from '@app/queries/hosting/useClientsIndicator';
import { Cell, Pie, PieChart } from 'recharts';
import ValueWithSign from '@widgets/table/components/value-with-sign';
import { IHostingIndicatorsFilter } from '@pages/Hosting/Main/filter';
import PercentageMonitor from '@shared/uikit/percentage-monitor';

interface IProps {
  filter: IHostingIndicatorsFilter;
}

export const RewardIndicator: FC<IProps> = ({ filter }) => {
  const clientsIndicatorFetcher = useClientsIndicator();

  const [data, setData] = useState<any | null>(null);
  const [isRubCurrencyActive, setCurrencyActive] = useState<boolean>(false);
  const [isUsdtActive, setUsdtActive] = useState<boolean>(true);
  const [activePieIndex, setActivePieIndex] = useState<number | null>(null);

  useEffect(() => {
    (async () => {
      if (null === filter) return;

      const clientsData = await clientsIndicatorFetcher.fetch(filter);
      setData({
        reward: 72300,
        reward_diff: 3.65,
      });
    })();
  }, [filter]);

  const chartData = [
    { name: 'Хостинг', value: 55000 },
    { name: 'Платежи', value: 45000 },
    { name: 'Инст. платёж', value: 35000 },
    { name: 'Доп. продажи', value: 25000 },
    { name: 'Прошивка', value: 15000 },
    { name: 'Пул', value: 5000 },
  ];

  const COLORS = [
    '#4598E6',
    '#B325F5',
    '#29A70F',
    '#18FFE4',
    '#DD1F91',
    '#FFDC18',
    '#2F18FF',
    '#18FF93',
    '#FF173A',
  ];

  return (
    <>
      <div className="flex flex-col p-[20px] w-full cursor-pointer]">
        <div className="text-[#777777] flex justify-between items-center mb-[10px]">
          <span>Доход за период</span>
          <div className="flex items-center gap-[3px] text-[12px]">
            <div
              onClick={() => {
                setCurrencyActive(true);
                setUsdtActive(false);
              }}
              className={` ${isRubCurrencyActive ? 'bg-[#373539] text-white opacity-0' : ''} flex items-center cursor-pointer h-[20px] px-[6px] border border-[#373539] rounded-[16px] border-opacity-80 opacity-80`}
            >
              РУБ
            </div>
            <div
              onClick={() => {
                setCurrencyActive(false);
                setUsdtActive(true);
              }}
              className={` ${isUsdtActive ? 'bg-[#373539] text-white opacity-0' : ''} flex items-center cursor-pointer h-[20px] px-[6px] border border-[#373539] rounded-[16px] border-opacity-80 opacity-80`}
            >
              USDT
            </div>
          </div>
        </div>

        {!clientsIndicatorFetcher.isPending && data ? (
          <>
            <div className="flex justify-between items-center mb-[10px]">
              <div className="text-[24px]">
                {data.reward !== null && data.reward !== undefined ? data.reward + ' USDT' : '-'}
              </div>
              <PercentageMonitor
                value={data.reward_diff}
                mode={data.hosting_diff > 0 ? 'up' : 'down'}
              />
            </div>
            <div className="grid md:grid-cols-2 gap-2 items-center">
              <div className="flex flex-wrap items-center row w-[128px] text-[10px] h-fit gap-[6px]">
                {chartData.map((item, index) => (
                  <div
                    className="cursor-pointer"
                    onClick={() => setActivePieIndex(activePieIndex === index ? null : index)}
                    style={{
                      opacity: null !== activePieIndex ? (activePieIndex === index ? 1 : 0.3) : 1,
                    }}
                  >
                    <ValueWithSign
                      width="8px"
                      height="8px"
                      gap="3px"
                      value={item.name}
                      colorNumber={COLORS[index % COLORS.length]}
                    />
                  </div>
                ))}
              </div>
              <div className="relative">
                <PieChart height={120} width={120} className="relative">
                  <Pie
                    data={chartData}
                    dataKey="value"
                    stroke="none"
                    startAngle={0}
                    endAngle={-360}
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={40}
                    outerRadius={60}
                    legendType="circle"
                    // onMouseEnter={(data) => {
                    //     console.log(data)
                    //     setActivePie(data.tooltipPayload)
                    // }}
                    // onMouseLeave={() => {
                    //     setActivePie(null)
                    // }}
                  >
                    {chartData.map((entry, index) => (
                      <Cell
                        opacity={null !== activePieIndex ? (activePieIndex === index ? 1 : 0.3) : 1}
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                </PieChart>
                {null !== activePieIndex ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      position: 'absolute',
                      width: '160px',
                      top: '50%',
                      left: 0,
                      background: 'black',
                      transform: 'translateY(-50%)',
                      padding: '5px',
                      marginLeft: '-20px',
                      borderRadius: '10px',
                      fontSize: '10px',
                    }}
                  >
                    <div className="flex justify-between">
                      <ValueWithSign
                        width="8px"
                        height="8px"
                        gap="3px"
                        value={`${chartData[activePieIndex].name}`}
                        color="bg-[#4598E6]"
                      />
                      <div className="whitespace-nowrap">
                        {chartData[activePieIndex].value} USDT
                      </div>
                    </div>
                    <div className="self-end">{chartData[activePieIndex].value} RUB</div>
                  </div>
                ) : null}
              </div>
            </div>
          </>
        ) : (
          <Loader size={45} loading={true} padding="9px" />
        )}
      </div>
    </>
  );
};
